import ButtonGroup from './ButtonGroup';
export default ButtonGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-button-group/src/index.js